import React from "react";
import { AdBanner } from "./ad-banner";
import { adServerService } from "../../services";
import { IAdBanner } from "../../types/AdTypes";
export const AdBanners: React.FC<{
    clientId: string;
}> = ({ clientId }) => {
    const [banners, setBanners] = React.useState<IAdBanner[]>();
    const getAllBanner = React.useCallback(async () => {
        const adsService = await adServerService.getAllBanners(clientId);
        setBanners(adsService);
        console.log(adsService);
    }, [clientId]);

    React.useEffect(() => {
        getAllBanner();
    }, [getAllBanner]);
    return (
        <div>
            {banners &&
                banners.map(
                    (banner) =>
                    banner.adStatus.key === 1 && (
                            <AdBanner
                                key={banner.adId}
                                source={banner.adImageSource}
                                url={banner.adImageUrl}
                                altText={banner.adImageAlttext}
                            />
                        )
                )}
        </div>
    );
};
